import { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import Offcanvas from 'react-bootstrap/Offcanvas';
import Header from '../../components/Header';
import ResponsiveTableRegion from '../../components/ResponsiveTableRegion';
import Filters from '../../components/Filters';
import SearchableSelect from '../../components/SearchableSelect';
import LabeledSelectionCheckbox from '../../components/LabeledSelectionCheckbox';
import { ventrisConfig } from '../../ventris.config';

import StudentPageIcon from '../../icons/StudentPageIcon';
import { getUseCaseTerminology } from '../../useCase';
import FilterIcon from '../../icons/FilterIcon';
import ArchiveIcon from '../../icons/ArchiveIcon';
import DeleteIcon from '../../icons/DeleteIcon';
import TestIcon from '../../icons/TestIcon';
import { completedTestDestination, launchableAssessmentsForUser } from '../../assessmentAccess';

type ClinicianStudentProps = {
};

let searchDebounce: any = null;

function ClinicianStudent({}: ClinicianStudentProps) {
  const terms = getUseCaseTerminology();
  const routeParams = useParams();
  const [user, setUser] = useState([] as any);
  const [tests, setTests] = useState([] as any);
  const [selectedTestIds, setSelectedTestIds] = useState([] as any);
  const [showFilters, setShowFilters] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showArchiveModal, setShowArchiveModal] = useState(false);
  const [showLaunchTest, setShowLaunchTest] = useState(false);
  const [students, setStudents] = useState([] as any);
  const [studentInfo, setStudentInfo] = useState({} as any);
  const [student, setStudent] = useState("" as any);
  const [test, setTest] = useState(3 as any);

  const [page, setPage] = useState(1);
  const [sizePerPage, setSizePerPage] = useState(20);
  const [totalSize, setTotalSize] = useState(0);
  const [sortFieldName, setSortFieldName] = useState("");
  const [sortDirection, setSortDirection] = useState("");
  const [organizationFilter, setOrganizationFilter] = useState("");
  const [clinicianFilter, setClinicianFilter] = useState("");
  const [studentFilter, setStudentFilter] = useState("");
  const [testFilter, setTestFilter] = useState("");
  const [completionStatusFilter, setCompletionStatusFilter] = useState("");
  const [archivedFilter, setArchivedFilter] = useState("");
  const [search, setSearch] = useState("");

  useEffect(() => {
    if (routeParams.studentId) {
      setStudentFilter(routeParams.studentId);

      let token = sessionStorage.getItem("token");
      fetch(ventrisConfig.url + '/api/student/' + routeParams.studentId, {
        method: 'get',
        headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
        }
      }).then(function (response) {
        return response.json();
      }).then(async function (data) {
        if (data.student) {
          setStudentInfo(data.student);
          setStudents([data.student]);
        setStudent(data.student.id);
        }
      });
    }
    loadTests(1);

    let currentUser = sessionStorage.getItem("current_user");
    const parsedUser = JSON.parse(currentUser!);
    setUser(parsedUser);
    const firstAssessment = launchableAssessmentsForUser(parsedUser)[0];
    if (firstAssessment) setTest(firstAssessment.schemaId);
  }, []);

  useEffect(() => {
      loadTests(page);
  }, [page, sizePerPage, sortFieldName, sortDirection, organizationFilter, clinicianFilter, studentFilter, testFilter, completionStatusFilter, archivedFilter]);

  useEffect(() => {
    if (searchDebounce) {
      clearTimeout(searchDebounce);
    }

    searchDebounce = setTimeout(() => {
      setPage(1);
      loadTests(1);
    }, 500);
  }, [search]);

  const loadTests = (page: number) => {
    setTimeout(() => {
      let token = sessionStorage.getItem("token");
      console.log(page);
      
      fetch(ventrisConfig.url + '/api/tests?page=' + page + '&sizePerPage=' + sizePerPage + '&sortField=' + sortFieldName + '&sortDirection=' + sortDirection + '&organization=' + organizationFilter + '&clinician=' + clinicianFilter + '&student=' + routeParams.studentId + '&test=' + testFilter + '&completionStatus=' + completionStatusFilter + '&archived=' + archivedFilter + '&search=' + search, {
        method: 'get',
        headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
        }
      }).then(function (response) {
        return response.json();
      }).then(async function (data) {
        setTests(data.tests);
        setTotalSize(data.total_records);
        setSelectedTestIds([]);
      });
    },
    100);
  }
  const back = () => {
    window.history.back();
  }

  const loadTest = (name: any, testId: any) => {
    document.location.href = "/test/" + name + "/" + testId;
  }

  const actuallyDeleteTests = () => {
    let token = sessionStorage.getItem("token");
    fetch(ventrisConfig.url + '/api/test/delete', {
      method: 'post',
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
      },
      body: JSON.stringify({
        tests: selectedTestIds.join("|")
      })
    }).then(function (response) {
      return response.json();
    }).then(async function (data) {
      setShowDeleteModal(false);
      setShowArchiveModal(false);
      setPage(1);
      loadTests(1);
    });
  }

  const actuallyArchiveTests = () => {
    let token = sessionStorage.getItem("token");
    fetch(ventrisConfig.url + '/api/test/' + (archivedFilter === 'true' ? 'unarchive' : 'archive'), {
      method: 'post',
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
      },
      body: JSON.stringify({
        tests: selectedTestIds.join("|")
      })
    }).then(function (response) {
      return response.json();
    }).then(async function (data) {
      setShowDeleteModal(false);
      setShowArchiveModal(false);
      setPage(1);
      loadTests(1);
    });
  }

  const startNewTest = () => {
    const id = Number(test);
    const assessment = launchableAssessmentsForUser(user).find((option) => option.schemaId === id);
    if (!assessment) return;
    const name = assessment.name;

    let token = sessionStorage.getItem("token");
    fetch(ventrisConfig.url + '/api/test', {
      method: 'post',
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
      },
      body: JSON.stringify({
        name: name,
        status: "Incomplete",
        test_schema_id: id,
        organization_id: user.organization_id,
        student_id: student,
      })
    }).then(function (response) {
      return response.json();
    }).then(async function (data) {
      if (data.success && data.test?.id) {
        document.location.href = "/test/" + name + "/" + data.test.id;
        return;
      }

      alert(data.message || "Unable to start a new test.");
    });
  }

  const toggleSelectedTest = (testId: string | number) => {
    const normalizedId = String(testId);
    setSelectedTestIds((prev: any) =>
      prev.includes(normalizedId)
        ? prev.filter((item: any) => item !== normalizedId)
        : [...prev, normalizedId]
    );
  }

  const checkboxFormatter = (cell: any, row: any, rowIndex: number, formatExtraData: any) => {
    const { selectedTestIds, toggleSelectedTest } = formatExtraData;
    return <LabeledSelectionCheckbox
      id={`student-test-select-${row.id}`}
      label={`Select ${row.name} test administered to ${row.student}`}
      checked={selectedTestIds.includes(String(row.id))}
      onChange={() => toggleSelectedTest(row.id)}
    />;
  }

  const testNameFormatter = (cell: any, row: any) => {
    return (
      <div>
        <span aria-hidden="true" className={row.archived ? "ventris-table-status-archived" : (row.status === "Complete" ? "ventris-table-status-completed" : "ventris-table-status-in-progress")}></span>
        <span className="visually-hidden">{row.archived ? "Archived: " : `${row.status}: `}</span>
        {cell}
      </div>
    );
  }

  const studentNameFormatter = (cell: any, row: any) => {
    return (
      <div>
        <Button variant="link" size="sm" onClick={() => loadTest(row.name, row.id)}>{cell}</Button>
      </div>
    );
  }

  const dateFormatter = (cell: any, row: any) => {
    return (
      <div>
        {(new Date(Date.parse(cell))).toLocaleDateString()}
      </div>
    );
  }

  const updatedFormatter = (cell: any, row: any) => {
    if (!cell) {
      return "";
    }

    const parsedDate = new Date(cell);
    if (isNaN(parsedDate.getTime())) {
      return cell;
    }

    const month = String(parsedDate.getMonth() + 1).padStart(2, "0");
    const day = String(parsedDate.getDate()).padStart(2, "0");
    const year = parsedDate.getFullYear();

    let hours = parsedDate.getHours();
    const minutes = String(parsedDate.getMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;
    const hoursString = String(hours).padStart(2, "0");

    return (
      <div>
        {`${month}/${day}/${year} ${hoursString}:${minutes} ${ampm}`}
      </div>
    );
  }

  const actionFormatter = (cell: any, row: any) => {
    return (
      <div>
        <Button variant="link" size="sm" onClick={() => row.status === "Complete" ? document.location.href = completedTestDestination(row) : loadTest(row.name, row.id)}>{row.status === "Complete" ? "Show Results" : "Continue Test"}</Button>
      </div>
    );
  }

  const columns = [
    {
      dataField: 'id',
      text: 'Select',
      headerFormatter: () => <span className="visually-hidden">Select tests</span>,
      formatter: checkboxFormatter,
      formatExtraData: { selectedTestIds, toggleSelectedTest }
    },
    {
      dataField: 'name',
      text: 'Test Name',
      sort: true,
      formatter: testNameFormatter
    },
    {
      dataField: 'student',
      text: `${terms.student} Name`,
      sort: true,
      formatter: studentNameFormatter
    },
    {
      dataField: 'completed_timestamp',
      text: 'Date Administered',
      formatter: dateFormatter
    },
    {
      dataField: 'updated_at',
      text: 'Last Updated',
      formatter: updatedFormatter
    },
    {
      dataField: 'clinician',
      text: 'Examiner',
      sort: true
    },
    {
      dataField: 'mode',
      text: 'Mode',
      sort: true
    },
    {
      dataField: 'id',
      text: 'Action',
      formatter: actionFormatter
    }
  ];

  const handleTabChange = (tabKey: string | null) => {
    if (tabKey === 'view-all') {
      setCompletionStatusFilter("");
      setArchivedFilter("");
    } else if (tabKey === 'completed') {
      setCompletionStatusFilter("Complete");
      setArchivedFilter("false");
    } else if (tabKey === 'in-progress') {
      setCompletionStatusFilter("Incomplete");
      setArchivedFilter("false");
    } else if (tabKey === 'archived') {
      setCompletionStatusFilter("");
      setArchivedFilter("true");
    }
    setPage(1);
  }

  const updateFilters = (organizations: any, clinician: string, student: string, test: string, status: string, subtest: string, norms: string) => {
    setOrganizationFilter(organizations);
    setClinicianFilter(clinician);
    setTestFilter(test);
    setCompletionStatusFilter(status);
    setPage(1);
  };

  const handleTableChange = (type: string, { page, sizePerPage, filters, sortField, sortOrder, cellEdit }: any) => {
    if ((sortField && sortFieldName != sortField) || (sortDirection && sortDirection != sortOrder)) {
      setPage(1);
    } else {
      setPage(page);
    }
    setPage(page);
    setSortFieldName(sortField ? sortField : "");
    setSortDirection(sortOrder ? sortOrder : "");
  }

  return (
    <Container fluid className="ventris-content-wrapper ventris-tests">
      <Header portal={sessionStorage.getItem("portal")!} page="students" />
      <Container as="main" id="main-content" tabIndex={-1}>
        <Row>
          <Col>
            <h1 className="page-header-no-margin align-items-center">
              <StudentPageIcon />
              <div className="flex-grow">{studentInfo?.first_name} {studentInfo?.last_name} ({studentInfo?.student_code})</div>
              <Form.Control type="search" className="ventris-search" aria-label="Search tests" placeholder="Search tests" value={search} onChange={(event) => setSearch(event.target.value)} />
              <Button variant="primary" className="ventris-button-primary ventris-button-primary-teal" onClick={() => setShowLaunchTest(true)}><TestIcon /> Launch a New Test</Button>
            </h1>
            <Button variant="link" size="sm" className="back-link" onClick={() => back()}>&#x276E; Back to {terms.students}</Button>
            <h3>{terms.student} Info</h3>
            <br />
            <ResponsiveTableRegion label={`${terms.student} information`} className="ventris-students">
              <div className="react-bootstrap-table react-bootstrap-table-rounded">
                <table className="table tabled-bordered">
                  <thead>
                    <tr>
                      <th></th>
                      <th>{terms.student} Name</th>
                      <th>{terms.student} ID</th>
                      <th>Grade</th>
                      <th>Birthdate</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td></td>
                      <td>{studentInfo?.first_name} {studentInfo?.last_name}</td>
                      <td>{studentInfo?.student_code}</td>
                      <td>{studentInfo?.grade}</td>
                      <td>{studentInfo?.birthdate}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </ResponsiveTableRegion>
            <br />
            <h3>{terms.student} Tests</h3>
            <div className={showFilters ? '' : 'hidden'}>
              <Filters updateFilters={updateFilters} hideFilters={['Organization', 'Student', 'Subtest', 'Norms']} />
            </div>
            <br />
            <div className="flex flex-row">
              <div className="flex-grow">
                <Tabs defaultActiveKey="view-all" onSelect={(event) => handleTabChange(event)}>
                  <Tab eventKey="view-all" title="View All">
                  </Tab>
                  <Tab eventKey="completed" title="Completed">
                  </Tab>
                  <Tab eventKey="in-progress" title="In Progress">
                  </Tab>
                  <Tab eventKey="archived" title="Archived">
                  </Tab>
                </Tabs>
              </div>
              <div className="ventris-action-links">
                <Button variant="link" size="sm" className="ventris-action-link" onClick={() => setShowFilters(!showFilters)}><FilterIcon /> {showFilters ? 'Hide Filter' : 'Show Filter'}</Button>
                <Button variant="link" size="sm" className="ventris-action-link" onClick={() => setShowArchiveModal(true)}><ArchiveIcon /> {archivedFilter === 'true' ? 'Unarchive' : 'Archive'} Selected</Button>
                <Button variant="link" size="sm" className="ventris-action-link" onClick={() => setShowDeleteModal(true)}><DeleteIcon /> Delete Selected</Button>
              </div>
            </div>
            <ResponsiveTableRegion label="Student tests">
              <BootstrapTable keyField='id' data={tests} columns={columns} bordered={true} remote={{pagination: true}} pagination={paginationFactory({ page, sizePerPage, totalSize })} onTableChange={handleTableChange} />
            </ResponsiveTableRegion>
          </Col>
        </Row>
      </Container>
      <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Are you sure you want to delete these item(s)? Deletion is permanent and cannot be undone.</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" className="ventris-button-secondary ventris-button-secondary-teal half-width" onClick={() => actuallyArchiveTests()}>No, Archive Instead</Button>
          <Button variant="primary" className="ventris-button-primary ventris-button-primary-teal half-width" onClick={() => actuallyDeleteTests()}>Yes, Confirm Delete</Button>
        </Modal.Footer>
      </Modal>
      <Modal show={showArchiveModal} onHide={() => setShowArchiveModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm {archivedFilter === 'true' ? 'Unarchive' : 'Archive'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Are you sure you want to {archivedFilter === 'true' ? 'unarchive' : 'archive'} these item(s)?</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" className="ventris-button-secondary ventris-button-secondary-teal half-width" onClick={() => setShowArchiveModal(false)}>No, Cancel</Button>
          <Button variant="primary" className="ventris-button-primary ventris-button-primary-teal half-width" onClick={() => actuallyArchiveTests()}>Yes, Confirm {archivedFilter === 'true' ? 'Unarchive' : 'Archive'}</Button>
        </Modal.Footer>
      </Modal>
      <Offcanvas show={showLaunchTest} onHide={() => setShowLaunchTest(false)} placement="end" scroll={false} backdrop={true} aria-labelledby="student-launch-test-title">
          <Offcanvas.Header className="offcanvas-header-green" closeButton>
              <Offcanvas.Title id="student-launch-test-title">Launch a Test</Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <Form.Group className="mb-3 ventris-form-element" controlId="student">
                <Form.Label>{terms.student}:</Form.Label>
                <SearchableSelect
                  ariaLabel={terms.student}
                  options={[...students]
                    .sort((a: any, b: any) =>
                      (a.last_name || "").localeCompare(b.last_name || "") ||
                      (a.first_name || "").localeCompare(b.first_name || "")
                    )
                    .map((student: any) => ({
                      value: student.id,
                      label: `${student.last_name}, ${student.first_name} (${student.student_code})`
                    }))}
                  value={student}
                  onChange={setStudent}
                  placeholder={`Select ${terms.student.toLowerCase()}`}
                  searchPlaceholder={`Search ${terms.students.toLowerCase()}...`}
                />
            </Form.Group>
            <Form.Group className="mb-3 ventris-form-element" controlId="test">
                <Form.Label>Test:</Form.Label>
                <Form.Select required aria-label="Test" value={test} onChange={(event) => setTest(event.target.value)}>
                  {launchableAssessmentsForUser(user).map((assessment) => <option key={assessment.name} value={assessment.schemaId}>{assessment.name}</option>)}
                </Form.Select>
            </Form.Group>
            <br /><br />
            <Button variant="primary" className="ventris-button-primary ventris-button-primary-teal full-width" onClick={startNewTest}>Launch Test</Button>
          </Offcanvas.Body>
      </Offcanvas>
    </Container>
  );
}

export default ClinicianStudent;
